import React from 'react';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import Report from '../../../../../../../../../models/components/report/Report';
import useStyles from '../Card.styles';
import useTranslation from '../../../../../../../../../components/localization/customHooks/Translation';
import RTEtext from '../../../../../../../../../components/RTEtext/RTEtext';
import Routes from '../../../../../../../../../routing/Routes';
import ReportPicture from '../picture/Picture';
import getPreviewContent from '../../../../../../../../user/components/tournamentReports/components/ReportCard/ReportCard.utils';
import AnglerLink from '../../../../../../../../../components/angler/anglerLink/AnglerLink';

const DesktopCard = (props: { report: Report }) => {
  const { report } = props;
  const classes = useStyles();
  const l10n = useTranslation();
  return (
    <div className={classes.wrapper}>
      <ReportPicture report={report} />
      <div className={classes.contentWrapper}>
        <Typography
          variant="h2"
          className={classes.link}
          component={Link}
          to={Routes.TournamentReport.path.replace(':id', report.id)}
        >
          {report.name}
        </Typography>
        <div>
          <RTEtext text={getPreviewContent(report) || ''} />
          <Link
            className={clsx(classes.readMore, classes.link)}
            to={Routes.TournamentReport.path.replace(':id', report.id)}
          >
            {l10n.shared.READ_MORE}
          </Link>
        </div>
        <div className={clsx(classes.footer, classes.additionalInfo, classes.locationWrapper)}>
          <AnglerLink anglerData={report.author} />
        </div>
      </div>
    </div>
  );
};

export default DesktopCard;
